import { getUserManagementModuleName } from './user-management.permissions';
import { ScopesPermissions } from './scopes.permissions';
import { getGroupPermissionFactory } from '../../../common/permissions/permissions.utils';
import { PermissionEnum } from '../../../common/permissions/permissions.Enum';

export class ScopesPermissionsPermissions {
    static GroupName = `${ScopesPermissions.GroupName}.Permissions`;

    static getPermissions = getGroupPermissionFactory(ScopesPermissions.GroupName);

    static Permissions = {
        Assign: ScopesPermissionsPermissions.getPermissions('Assign'),
        Revoke: ScopesPermissionsPermissions.getPermissions('Revoke'),
        ReadAll: ScopesPermissionsPermissions.getPermissions(PermissionEnum.READ_ALL)
    };
}
